import { render } from "./NoAccess.vue?vue&type=template&id=0c6700c2"
import script from "./NoAccess.vue?vue&type=script&lang=js"
export * from "./NoAccess.vue?vue&type=script&lang=js"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__